var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "jumbotron-background" }, [
      _c("div", { staticClass: "container" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("jumbotron.heading")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("jumbotron.heading2")))]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("jumbotron.slogan")))])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          {
            staticClass: "content-module-wrapper",
            staticStyle: { "border-top-color": "transparent" }
          },
          [
            _c("div", { staticClass: "content-module" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("enter_barcode")))]),
                    _vm._v(" "),
                    _c("search-form", {
                      attrs: { example: "4000001000005" },
                      on: { error: _vm.setError, submit: _vm.submit },
                      model: {
                        value: _vm.search,
                        callback: function($$v) {
                          _vm.search = $$v
                        },
                        expression: "search"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6 bullets" }, [
                  _c("p", [
                    _c("span", {
                      staticClass: "fa fa-check-circle color-grass"
                    }),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("bullets.1")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", {
                      staticClass: "fa fa-check-circle color-grass"
                    }),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("bullets.2")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", {
                      staticClass: "fa fa-check-circle color-grass"
                    }),
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("bullets.3")) +
                        "\n            "
                    )
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm.error
          ? _c("search-form-alerts", {
              attrs: { error: _vm.error },
              on: { suggest: _vm.applySuggestion }
            })
          : _c("div", { staticStyle: { height: "142px" } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container",
        staticStyle: { "margin-top": "15px", "margin-bottom": "50px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "content-module-wrapper",
            staticStyle: { "border-top-color": "transparent" }
          },
          [
            _c("div", { staticClass: "content-module" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("enter_company")))]),
                    _vm._v(" "),
                    _c("company-search-form", {
                      on: { submit: _vm.companySubmit }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76114db4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76114db4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/Start.vue
// module id = null
// module chunks = 